<template>
  <div
    v-if="paymentMethods.PaymentMethods && paymentMethods.PaymentMethods.length"
    class="payment-methods"
  >
    <SfRadio
      v-for="payment in paymentMethods.PaymentMethods"
      :key="payment.Name"
      :label="payment.Name"
      :details="currencyFormatter().format(payment.Fee)"
      :description="payment.Description"
      name="PaymentMethod"
      :value="payment.Name"
      :required="true"
      v-model="paymentMethod"
      @input="handleInputChange(payment)"
    />
  </div>
  <div v-else>
    <p class="text-danger">
      {{ $t('No payment methods available for selected shipping.') }} <br />
      {{ $t('Go back and select different shipping option.')}}
    </p>
  </div>
</template>
<script>
import { SfRadio } from '@storefront-ui/vue';
import { config } from '@/modules/core';

export default {
  name: 'PaymentMethods',
  mixins: [config],
  components: {
    SfRadio,
  },
  props: {
    paymentMethods: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({
        name: '',
        system: '',
      }),
    },
  },
  data() {
    return {
      paymentMethod: '',
    };
  },
  methods: {
    handleInputChange(data) {
      this.$emit('input', {
        name: data.Name,
        system: data.PaymentMethodSystemName,
      });
    },
  },
  watch: {
    value: {
      handler() {
        this.paymentMethod = this.value.name;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.sf-button,
.sf-input,
.sf-checkbox {
  margin-bottom: var(--spacer-sm);
}
</style>
